import { render, staticRenderFns } from "./IotVendorForm.vue?vue&type=template&id=38578c13&scoped=true"
import script from "./IotVendorForm.vue?vue&type=script&lang=ts"
export * from "./IotVendorForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38578c13",
  null
  
)

export default component.exports